import React from 'react'
import Select from 'react-select'
import { selectStyleDark, selectStyleLight } from '../../../utils/sharedCareTeamLogic'

export default function PlaceOfServiceSelector({ listPOS, onPOSSelect, value, disabled, theme }) {
  const options =
    listPOS?.length > 0
      ? listPOS?.map((item) => ({
          label: (item?.code ? `${item?.code || ''} - ` : '') + item?.place_of_service,
          value: item?.code,
        }))
      : [{ label: 'No Available POS', value: '' }]

  return (
    <Select
      menuShouldScrollIntoView={false}
      aria-label="Place of service"
      className="encounter-selectbox-input break-important"
      styles={theme === 'light' ? selectStyleLight : selectStyleDark}
      onChange={({ value }) => {
        onPOSSelect(value)
      }}
      value={options?.find((opt) => value === opt.value)}
      options={options}
      isSearchable={false}
      isDisabled={disabled}
    />
  )
}
